import React, { useState } from 'react';
import { TRACKING_ACTIONS, TRACKING_ELEMENT_TYPES, trackEvent } from '@medflex/utils/Tracking';
import { showSuccessToast, showAlertToast } from '@medflex/components/stories/Toast';
import Modal from '@medflex/components/stories/Modal';
import Button from '@medflex/components/stories/Button';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import usePhysicianStatusEdit from '../hooks/usePhysicianStatusEdit';

const StatusDeleteModal = () => {
  const { t } = useTranslation('physician');
  const [isLoading, setIsLoading] = useState(false);
  const { savePhysicianStatus } = usePhysicianStatusEdit();
  const history = useHistory();

  const goBack = () => history.goBack();

  const handleConfirmDelete = async event => {
    setIsLoading(true);

    const success = await savePhysicianStatus({ status: '' });
    if (success) {
      showSuccessToast(t('toasts.status.success.title'), t('toasts.status.success.text'), {
        toastId: 'statusDeleteSuccess',
      });
      trackEvent(event, {
        zone: 'Arzt_Hinweis',
        action: TRACKING_ACTIONS.SUBMIT,
        elementType: TRACKING_ELEMENT_TYPES.FORM,
        actionText: 'save',
      });
      goBack();
    } else {
      showAlertToast(t('toasts.status.alert.title'), t('toasts.status.alert.text'), {
        toastId: 'statusDeleteFailed',
      });
      trackEvent(event, {
        zone: 'Arzt_Hinweis',
        action: TRACKING_ACTIONS.SUBMIT,
        elementType: TRACKING_ELEMENT_TYPES.FORM,
        actionText: 'failure',
      });
    }
    setIsLoading(false);
  };

  const handleClose = event => {
    goBack();
    trackEvent(event, { zone: 'StatusModal', actionText: TRACKING_ACTIONS.CLOSE });
  };

  return (
    <Modal title={t('modals.status.delete.title')} showCloseButton onClickCloseButton={handleClose}>
      <div>{t('modals.status.delete.text')}</div>
      <Button
        className="my-6 self-start"
        type="button"
        onClick={handleConfirmDelete}
        isLoading={isLoading}
      >
        {t('modals.status.delete.button')}
      </Button>
    </Modal>
  );
};

export default StatusDeleteModal;
